import React from 'react'
import {Link} from 'react-router-dom'
import {LinkComponent, SocialLinkComponent} from '../utils/links'
import {CgClose} from 'react-icons/cg'
import {useGlobalContext} from '../context'

function Sidebar() {
    const {isSidebarOpen, closeSidebar} = useGlobalContext();
    return (
        <aside className={"sidebar" + (isSidebarOpen ? " sidebar-visible" : "")} onClick={closeSidebar}>
            <div className={"sidebar-content" + (isSidebarOpen ? " sidebar-slided" : "")} onClick={(ev)=>{ev.stopPropagation()}}>
                <header className="sidebar-header">
                    <div className="sidebar-close">
                        <CgClose onClick={closeSidebar}/>
                    </div>
                    <Link to="/" className="nav-title" onClick={closeSidebar}>
                        <h3>Ceppo Trekking</h3>
                    </Link>
                    <hr/>
                </header>
                <LinkComponent classLink={"link-component-sidebar"}/>
                <SocialLinkComponent classSocial={"social-component-sidebar"}/>
            </div>
        </aside>
    )
}

export default Sidebar
